const colors = {
  extraLightGrey: '#f2f2f2',
  lightGrey: '#e5e5e5',
  grey: '#999',
  white: '#fff',
  ebbBlue: '#1a2c6a',
  ebbDarkBlue: '#182d6a',
  ebbRed: '#d61825',
  bg: '#0e1133',
};
export default colors;



// WEBPACK FOOTER //
// ./src/utils/colors.js